webpackJsonp([31267650549131],{

/***/ 509:
/***/ (function(module, exports) {

	module.exports = {"data":{"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/bold-mage"},"excerpt":"Quanto et ius coniunctis urbes Sedisti civiliter Lorem  markdownum  Ixione palus  semper peritura barbaque  in aureus\nobliquum erigitur…","timeToRead":2,"frontmatter":{"title":"Bold Mage","tags":["programming","stuff","other"],"cover":"https://unsplash.it/1280/500/?random?BoldMage","date":"01/01/2017","author":"guinevere"}}}]},"allAuthorsJson":{"edges":[{"node":{"id":"guinevere","name":"Guinevere Kuiper","image":"https://randomuser.me/api/portraits/women/17.jpg","url":"https://randomuser.me/api/?seed=user1","bio":"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam laoreet lorem nec ligula aliquet, porta blandit augue luctus. Vivamus ac quam diam. Sed vestibulum pharetra hendrerit.","location":"Simpelveld, Groningen","socialUrls":null}}]}},"pathContext":{"author":"guinevere"}}

/***/ })

});


// WEBPACK FOOTER //
// path---author-guinevere-0425a6130b0313f98d2e.js